import { DynamicFormControl } from './dynamic-form-control';
import { DynamicFormControlOptions } from './dynamic-form-control.models';
import { defaultOptions } from './dynamic-form-control';
import { extend } from 'lodash-es';

export class DynamicFormEmpty extends DynamicFormControl<string> {
	constructor(options: DynamicFormControlOptions<any> = { ...defaultOptions }) {
		super(
			extend(options, {
				controlType: 'empty',
				controlTypeEmpty: true,
			})
		);
	}
}
